<template>
  <page>
    <template slot="content">
      <help-content :title="'バックグラウンド実行中のアプリの強制終了を防ぐ方法(Android)'">
        <template slot="content">
          <div class="text">
            「携帯計測の場合、歩数がカウントされない時の対応法(Android)」をご参考ください。<br>解決できない場合は、ヘルプデスクまでお問い合わせください。お問い合わせ先:<a href="mailto:help@werunclub.net">help@werunclub.net</a>。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help7.vue